import { render, staticRenderFns } from "./MyCashup.vue?vue&type=template&id=0fbb9212"
import script from "./MyCashup.vue?vue&type=script&lang=js"
export * from "./MyCashup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports